let maxmindLoadCalled = false;

/**
 * See:
 * https://dev.maxmind.com/minfraud/evaluate-a-transaction
 * https://dev.maxmind.com/minfraud/track-devices
 */
export const loadMaxmindMinfraudDeviceTracking = () => {
	if (maxmindLoadCalled) {
		return;
	}

	maxmindLoadCalled = true;

	// Arbitrarily delay this to avoid any possible UI jank
	// during slide transitioning, etc, caused by high main
	// JS thread CPU usage when it executes.
	setTimeout(() => {
		var mmapiws = window.__mmapiws = window.__mmapiws || {};
		mmapiws.accountId = '120509';
		var element = document.createElement('script');
		element.async = true;
		element.src = 'https://device.maxmind.com/js/device.js';
		document.body.appendChild(element);
	}, 1000);
}

export const trackGtmEvent = ({ event, category, action = '', label = '', value, ...rest }) => {
	try {
		dataLayer.push(
			value
				? {
					...rest,
					event: event || category,
					eventCategory: category,
					eventAction: action,
					eventLabel: label,
					eventValue: value,
				}
				: {
					...rest,
					event: event || category,
					eventCategory: category,
					eventAction: action,
					eventLabel: label,
				}
		);
	} catch (e) {
		console.error(e);
	}
};

export const trackBingConversion = ({ action, value }) => {
	const track = new Image();
	track.src = `//flex.msn.com/mstag/tag/9eaf3126-408c-4ff7-a983-d0338a6444c2/analytics.html?dedup=1&domainId=3147929&type=1&revenue=${value}&actionid=${action}`;
};

/**
 * See: https://github.com/GigSalad/gigsalad.com/issues/4294
 * See: https://intercom.help/mntn/en/articles/6633922-pixel-installation-guide-site-direct
 */
export const trackMountainConversion = ({ value }) => {
	(
		function() {
			var p, q, m,
				o = "35724",
				l = "",
				i = value,
				c = "",
				k = "",
				g = "",
				j = "",
				u = "",
				shadditional = "";

			try {
				p = top.document.referer !== "" ? encodeURIComponent(top.document.referrer.substring(0, 512)) : ""
			} catch (n) {
				p = document.referrer !== null ? document.referrer.toString().substring(0, 512) : ""
			}

			try {
				q = window && window.top && document.location && window.top.location === document.location ? document.location : window && window.top && window.top.location && "" !== window.top.location ? window.top.location : document.location
			} catch (b) {
				q = document.location
			}

			try {
				m = parent.location.href !== "" ? encodeURIComponent(parent.location.href.toString().substring(0, 512)) : ""
			} catch (z) {
				try {
					m = q !== null ? encodeURIComponent(q.toString().substring(0, 512)) : ""
				} catch (h) {
					m = ""
				}
			}

			var A,
				y = document.createElement("script"),
				w = null,
				v = document.getElementsByTagName("script"),
				t = Number(v.length) - 1,
				r = document.getElementsByTagName("script")[t];

			if (typeof A === "undefined") {
				A = Math.floor(Math.random() * 100000000000000000)
			}

			w = "https://dx.mountain.com/spx?conv=1&shaid=" + o + "&tdr=" + p + "&plh=" + m + "&cb=" + A + "&shoid=" + l + "&shoamt=" + i + "&shocur=" + c + "&shopid=" + k + "&shoq=" + g + "&shoup=" + j + "&shpil=" + u + shadditional;
			y.type = "text/javascript";
			y.src = w;
			r.parentNode.insertBefore(y, r);
		}()
	);
};

/**
 * Image-based Pinterest conversion tracking.
 * See: https://help.pinterest.com/en/business/article/add-event-codes
 */
export const trackPinterestConversion = ({ leadType, clickId, eventId, groupId, email }) => {
	const track = new Image();

	const query = new URLSearchParams({
		tid: 2614313055573,
		event: 'lead',
		'pd[em]': email,
		'pd[external_id]': groupId,
		'pd[click_id]': clickId,
		'ed[action_source]': 'web',
		'ed[lead_type]': leadType,
		'ed[event_id]': eventId,
		noscript: 1
	});

	track.src = `https://ct.pinterest.com/v3/?${query}`;
};

export const trackRedditConversion = ({ eventType, matchKeys }) => {
	!function(w,d){if(!w.rdt){var p=w.rdt=function(){p.sendEvent?p.sendEvent.apply(p,arguments):p.callQueue.push(arguments)};p.callQueue=[];var t=d.createElement("script");t.src="https://www.redditstatic.com/ads/pixel.js",t.async=!0;var s=d.getElementsByTagName("script")[0];s.parentNode.insertBefore(t,s)}}(window,document);
	rdt("init", "a2_gnm9qtp1sgti");
	rdt("track", eventType, matchKeys);
};

export const conversions = {
	trackGtmEvent,
	trackBingConversion,
	trackMountainConversion,
	trackPinterestConversion,
	trackRedditConversion,
};
export default conversions;
